<template>
  <div class="IdRazdel Edit">
    <form @submit.prevent="saveUser">
      <div class='opIdPhone'>телефон</div>
      <input type='text' class='IdPhone' v-model="user.phone">
      <div class='opIdSite'>сайт или страница</div>
      <input type='text' class='IdSite' v-model="user.link">
      <div class='opIdOpis'>главное обо мне</div>
      <textarea maxlength='220' class='IdOpis' v-model="user.description"></textarea>

      <!-- <div class="opIdFacilitator">фасилитатор</div>
      <div>
        <select v-model="user.facilitator" class="IdFacilitator">
          <option value="true">Да</option>
          <option value="false">Нет</option>
        </select>
      </div> -->

      <div class='BtAddUserInfo' @click.prevent="saveUser"></div>
    </form>
  </div>
</template>

<script>
import { pick } from 'lodash';
import { API_ROOT } from "@/utils/api_root";

export default {
  props: {
    user: { type: Object, default: function() { return {}; } }
  },
  methods: {
    saveUser() {
      console.log('User component saveUser this', this);
      const params = pick(this.user, ['phone', 'link', 'description']);
      console.log('User component saveUser params', params);

      this.$http.patch(`${API_ROOT}/users/${this.user.id}.json`, {user: params})
        .then(response => {
          console.log('User component saveUser success', response);
          this.flash('Данные сохранены', 'success', {timeout: 3000});
          this.$store.commit('currentUser', response.data);
          this.$emit('hideAction')
        })
        .catch(error => {
          console.log('User component error', error, error.response.data.errors);
          // this.authError = error.response.data.errors[0];
          this.flash('Ошибка сохранения', 'error');
        });
    }
  }
};
</script>
